import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import './App.css';
import About from "./components/About/About";
// import Allprojects from "./components/Projects/Projects";
import Notfound from "./components/Notfound/Notfound";
import Home from "./components/Home/Home";
import Contact from "./components/Contact/Contact";
import Header from './components/Header/Header';
import Allprojects from './components/Allprojects/Allprojects';




function App() {

  return (
   

    <Router>
    <div>
    <Switch>
 
  <Route exact path='/'>
  <Home></Home>
  </Route>
  
  <Route path='/Home'>
  <Home></Home>
  </Route>

  <Route path='/About'>
  <Header></Header>
  <About/>
  </Route>

  <Route path='/Projects'>
  <Header></Header>
  <Allprojects></Allprojects>
  </Route>

  <Route path='/Contact'>
  <Header></Header>
  <Contact></Contact>
  </Route>

  <Route path="*">
  <Notfound></Notfound>
  </Route>

  
  </Switch>
  </div>
    </Router>
    
  );
}

export default App;
